import { Texture } from "three";
import { IFsFileType } from "@/components/r3f-components/component-data-structure";
import { FsBaseFile } from "./base";

export class FsImage extends FsBaseFile {
    type: IFsFileType.Image | IFsFileType.Image360 | IFsFileType.ImageTarget = IFsFileType.Image
    imageUrl: string

    private _imageBlob: Blob | undefined
    private _aspectRatio: number | undefined
    private _texture: Texture | undefined

    constructor(fileId: string, name: string) {
        super(fileId, name)
        const url = new URL(this.baseUrl)
        url.pathname = `${url.pathname}/img`
        this.imageUrl = url.toString()
    }

    getImageUrl() {
        return this.imageUrl
    }

    async getBlob() {
        if (typeof this._imageBlob === 'undefined') {
            const resp = await fetch(this.getImageUrl())
            this._imageBlob = await resp.blob()
        }
        return this._imageBlob
    }

    async load() {
        await this.getBlob()
        return this
    }

    async createImageBitmap() {
        return createImageBitmap(await this.getBlob(), { imageOrientation: 'flipY' })
    }

    async getAspectRatio() {
        if (typeof this._aspectRatio === 'undefined') {
            const img = await this.createImageBitmap()
            if (img.height === 0) return 1
            this._aspectRatio = img.width / img.height
        }
        return this._aspectRatio
    }

    async getTexture() {
        this._texture = this._texture ?? new Texture();
        if (this._texture.image === null) {
            this._texture.image = await this.createImageBitmap()
            this._texture.needsUpdate = true;
        }
        return this._texture
    }
}
